import { createContext, useContext } from 'react';

const translations = {
  appTitle: 'مشروع حفظ الستين',
  mutashabihatMenu: 'المتشابهات',
  mutashabihatSubtitle: 'المتشابهات برواية قالون حتى صفحة التوقف',
  mutashabihatTitle: 'المتشابهات في القرآن الكريم',
  qalunNarration: 'برواية قالون عن نافع',
  studiedThroughPage: 'عرض المتشابهات حتى الصفحة',
  savedProgressPage: 'آخر صفحة مسجلة في المقاطع',
  applyPageLimit: 'عرض',
  mutashabihatCount: 'مجموعة متشابهات',
  noMutashabihat: 'لا توجد مجموعات متشابهة حتى هذه الصفحة',
  noMutashabihatMatch: 'لا توجد نتائج مطابقة للبحث',
  mutashabihatLoadError: 'تعذر تحميل المتشابهات. حاول مرة أخرى.',
  searchMutashabihat: 'ابحث في المتشابهات أو السور...',
  retry: 'إعادة المحاولة',
  loadMore: 'عرض المزيد',
  dataSource: 'مصدر بيانات المتشابهات',
  page: 'صفحة',
  ayah: 'آية',

  surahs: 'السور',
  addSurah: 'إضافة سورة',
  editSurah: 'تعديل السورة',
  deleteSurah: 'حذف السورة',
  surahName: 'اسم السورة',
  surahNameArabic: 'الاسم بالعربية',
  surahNameFrench: 'الاسم بالفرنسية',
  surahNumber: 'الرقم',
  excerpts: 'المقاطع',
  addExcerpt: 'إضافة مقطع',
  editExcerpt: 'تعديل المقطع',
  deleteExcerpt: 'حذف المقطع',
  pageNumber: 'الصفحة',
  wajhNumber: 'وجه السورة',
  mushafPageNumber: 'صفحة المصحف',
  mushafPageHint: 'وجه السورة هو ترتيب الصفحة داخل السورة، وصفحة المصحف هي رقمها في المصحف برواية قالون.',
  invalidMushafPage: 'أدخل رقم صفحة صحيحاً من المصحف.',
  similarityThreshold: 'أقل عدد كلمات متتابعة مشتركة',

  noGroupsOnPage: 'لا توجد متشابهات جديدة في هذه الصفحة.',
  sharedPhraseHint: 'تُعرض المجموعات التي تشترك آياتها في هذه السورة على الأقل من الكلمات المتتابعة.',
  noMutashabihatAtThreshold: 'لا توجد مجموعات تطابق هذا الحد من التشابه حتى الصفحة المسجلة.',
  pageMutashabihat: 'مجموعة متشابهة',
  latestStudiedPage: 'آخر صفحة محفوظة',
  viewMatchDetails: 'عرض المتشابهات',
  matchingAyahs: 'آيات متشابهة',
  noSurahs: 'لا توجد سور مضافة',
  noExcerpts: 'لا توجد مقاطع صوتية',
  addFirstSurah: 'أضف سورتك الأولى',
  addFirstExcerpt: 'أضف مقطعك الصوتي الأول',
  save: 'حفظ',
  cancel: 'إلغاء',
  delete: 'حذف',
  confirm: 'تأكيد',
  confirmDelete: 'هل أنت متأكد من الحذف؟',
  selectAudio: 'اختر ملف صوتي',
  dropAudio: 'اسحب ملف صوتي هنا',
  startTime: 'البداية',
  endTime: 'النهاية',
  duration: 'المدة',
  trimAudio: 'قص الصوت',
  previewSelection: 'معاينة التحديد',
  saveExcerpt: 'حفظ المقطع',
  play: 'تشغيل',
  pause: 'إيقاف',
  loop: 'تكرار',
  shuffle: 'عشوائي',
  continuous: 'متواصل',
  volume: 'الصوت',
  nowPlaying: 'يتم تشغيل',
  settings: 'الإعدادات',
  theme: 'المظهر',
  language: 'اللغة',
  light: 'فاتح',
  dark: 'داكن',
  loading: 'جاري التحميل...',
  error: 'خطأ',
  success: 'تم بنجاح',
  audioEditor: 'محرر الصوت',
  replaceAudio: 'استبدال الصوت',
  dragToReorder: 'اسحب لإعادة الترتيب',
  searchSurahs: 'البحث عن سورة...',
  noResults: 'لا توجد نتائج',
  noMatchFor: 'لا توجد سورة مطابقة لـ',
  clearSearch: 'مسح البحث',
  noSurahAvailable: 'لا توجد سور متاحة',
  offlineCache: 'تم التحميل من الذاكرة المؤقتة',
  offlineNoData: 'لا توجد بيانات - يرجى الاتصال أولاً',
  offlineBanner: 'وضع بدون اتصال - المقاطع المحفوظة فقط متاحة',
  adjustAudio: 'تعديل القص',
  loadingAudio: 'جاري تحميل الصوت...',
  setStartHere: 'تحديد البداية هنا',
  setEndHere: 'تحديد النهاية هنا',
  titleOptional: 'العنوان (اختياري)',
  titlePlaceholder: 'مثال: الآيات ١-٥، المقدمة...',
  trimming: 'جاري القص...',
  excerptsCachedOffline: 'تم تحميل المقاطع من الذاكرة المؤقتة',
  cannotLoadExcerpts: 'تعذر تحميل المقاطع',
  excerptNotAvailableOffline: 'المقاطع غير متاحة بدون اتصال',
};

const LanguageContext = createContext({
  language: 'ar',
  t: (key) => key,
  isRTL: true,
});

export const LanguageProvider = ({ children }) => {
  const t = (key) => translations[key] || key;

  // Always RTL Arabic
  if (typeof window !== 'undefined') {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
  }

  return (
    <LanguageContext.Provider value={{ 
      language: 'ar', 
      t,
      isRTL: true,
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
